import { combineEpics, ofType } from "redux-observable";
import { of } from "rxjs/observable/of";
import { catchError, map, mergeMap, pluck } from "rxjs/operators";

const SCOPE = "order-entry/city/";

export const GET_CITIES = `${SCOPE}GET_CITIES`;
export const GET_CITIES_ERROR = `${SCOPE}GET_CITIES_ERROR`;
export const SET_CITIES = `${SCOPE}SET_CITIES`;

export const GET_CITIES_WITH_REGIONS = `${SCOPE}GET_CITIES_WITH_REGIONS`;
export const GET_CITIES_WITH_REGIONS_ERROR = `${SCOPE}GET_CITIES_WITH_REGIONS_ERROR`;
export const SET_CITIES_WITH_REGIONS = `${SCOPE}SET_CITIES_WITH_REGIONS`;

export const GET_CITIES_WITH_TYPEAHEAD = `${SCOPE}GET_CITIES_WITH_TYPEAHEAD`;
export const GET_CITIES_WITH_TYPEAHEAD_ERROR = `${SCOPE}GET_CITIES_WITH_TYPEAHEAD_ERROR`;
export const SET_CITIES_WITH_TYPEAHEAD = `${SCOPE}SET_CITIES_WITH_TYPEAHEAD`;

const STORE_LOCATOR_CITY_URL = "/store-locator-international/locations/city";
const STORE_LOCATOR_CITY_URL_TYPEAHEAD =
  "/store-locator-typeahead-service/search/cities";

export function getCities({ query = {} } = {}) {
  return {
    type: GET_CITIES,
    power: true,
    query,
    url: STORE_LOCATOR_CITY_URL,
  };
}

export function getCitiesError(error) {
  return {
    type: GET_CITIES_ERROR,
    error,
  };
}

export function setCities(cities = {}) {
  return {
    type: SET_CITIES,
    cities,
  };
}

export function getCitiesWithRegions({ query = {} } = {}) {
  return {
    type: GET_CITIES_WITH_REGIONS,
    power: true,
    query,
    url: STORE_LOCATOR_CITY_URL,
  };
}

export function getCitiesWithRegionsError(error) {
  return {
    type: GET_CITIES_WITH_REGIONS_ERROR,
    error,
  };
}

export function setCitiesWithRegions(citiesWithRegions = []) {
  return {
    type: SET_CITIES_WITH_REGIONS,
    citiesWithRegions,
  };
}

export function getCitiesWithTypeahead({ query = {} } = {}) {
  return {
    type: GET_CITIES_WITH_TYPEAHEAD,
    power: true,
    query,
    url: STORE_LOCATOR_CITY_URL_TYPEAHEAD,
  };
}

export function getCitiesWithTypeaheadError(error) {
  return {
    type: GET_CITIES_WITH_TYPEAHEAD_ERROR,
    error,
  };
}

export function setCitiesWithTypeahead(citiesWithTypeahead = []) {
  return {
    type: SET_CITIES_WITH_TYPEAHEAD,
    citiesWithTypeahead,
  };
}

export const initialState = {};

export default function reducer(
  state = initialState,
  { type, ...action } = {}
) {
  switch (type) {
    case SET_CITIES:
      return action.cities;
    case SET_CITIES_WITH_REGIONS:
      return { ...action.citiesWithRegions };
    case SET_CITIES_WITH_TYPEAHEAD:
      return { ...action.citiesWithTypeahead };
    default:
      return state;
  }
}

export const getCitiesEpic = (action$, redux, { fetch }) =>
  action$.pipe(
    ofType(GET_CITIES),
    mergeMap((action) =>
      fetch(action).pipe(
        pluck("response"),
        map((cities) =>
          setCities(
            cities.reduce(
              (all, { name }) =>
                Object.assign(all, {
                  [name]: name,
                }),
              {}
            )
          )
        ),
        catchError((error) => of(getCitiesError(error)))
      )
    )
  );

export const getCitiesWithRegionsEpic = (action$, redux, { fetch }) =>
  action$.pipe(
    ofType(GET_CITIES_WITH_REGIONS),
    mergeMap((action) =>
      fetch(action).pipe(
        pluck("response"),
        map((citiesWithRegions) => setCitiesWithRegions(citiesWithRegions)),
        catchError((error) => of(getCitiesWithRegionsError(error)))
      )
    )
  );

export const getCitiesWithTypeaheadEpic = (action$, redux, { fetch }) =>
  action$.pipe(
    ofType(GET_CITIES_WITH_TYPEAHEAD),
    mergeMap((action) =>
      fetch(action).pipe(
        pluck("response"),
        map((citiesWithTypeahead) =>
          setCitiesWithTypeahead(citiesWithTypeahead)
        ),
        catchError((error) => of(getCitiesWithTypeaheadError(error)))
      )
    )
  );

export const epics = combineEpics(
  getCitiesEpic,
  getCitiesWithRegionsEpic,
  getCitiesWithTypeaheadEpic
);
